@if (details$ | async; as details) {
  <div class="grid grid-cols-2 gap-3">
    <div class="col-span-2">
      <app-details-view label="Nazwa">
        {{ details.name }}
      </app-details-view>
    </div>

    <app-details-view label="Identyfikator">
      {{ details.id }}
    </app-details-view>

    <app-details-view label="Numer artykułu (SKU)">
      {{ details.sku }}
    </app-details-view>

    <app-details-view label="Lokalizacja">
      @if (details.localization) {
        {{ details.localization }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Właściciel">
      @if (details.ownerId | fetchWarehouseOwnerById | async; as owner) {
        {{ owner.label }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Marka kosmetyczna">
      {{ details.brand }}
    </app-details-view>

    <app-details-view label="Produkt promocyjny">
      {{ details.promotion | boolean }}
    </app-details-view>

    <app-details-view label="Rodzaj">
      {{ details.type | warehouseProductType | async }}
    </app-details-view>

    <app-details-view label="Ilość">
      {{ details.quantity }}
    </app-details-view>

    <app-details-view label="Jednostka miary">
      <app-quantity-unit [unit]="details.unit" />
    </app-details-view>

    <app-details-view label="Okres przydatności">
      @if (isNotNil(details.durabilityInformation)) {
        {{ details.durabilityInformation }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Data utworzenia">
      {{ details.createdAt | dateFormat }}
    </app-details-view>

    <app-details-view label="Miara towaru">
      @if (details.measure) {
        {{ details.measure }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <div class="col-span-2 rounded-sm border border-gray-200 p-4">
      <h5>Historia zmian stanu magazynowego</h5>

      <p-divider appPrimengDivider />

      <app-warehouse-product-quantity-history-list
        [owner]="owner()"
        [id]="id()" />
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
